// extracted by mini-css-extract-plugin
export default {"env-list-item":"CurEnvItem_env-list-item__s1Yao","env-tit":"CurEnvItem_env-tit__ttszN","env-icon":"CurEnvItem_env-icon__VmpsO","env-data":"CurEnvItem_env-data__YTlAk"};